import React from 'react';
import { contacts } from '../../Data/Data';
import { BiMailSend } from 'react-icons/bi';
import { MdMarkEmailRead } from 'react-icons/md';
import emailjs from '@emailjs/browser';
import './Contact.scss';
import { useRef } from 'react';
import { useState } from 'react';
const Contact = () => {
  const [submitted, setSubmitted] = useState(false);
  const [button, setButton] = useState(true);
  const form = useRef();
  const sendEmail = (e) => {
    e.preventDefault();
    setButton(false);
    emailjs
      .sendForm('nisad', 'template_wt045p6', form.current, 'n7r7jr1AeFKO-BYB8')
      .then(
        (result) => {
          e.target.reset();
          setSubmitted(true);
          setTimeout(() => {
            setSubmitted((prev) => !prev);
          }, 15000);
          setButton(true);
        },
        (error) => {}
      );
  };
  return (
    <div id="contact" className="min-h-screen flex flex-col gap-5  pb-10">
      <h1
        bg-text="Contact"
        className={` 
        
         heading__text text-center text-teal-400  font-sans sm:text-[5rem] text-[3rem] font-semibold mt-5`}
      >
        Contact
      </h1>
      <div className="flex items-center justify-center flex-wrap md:gap-10 gap-5">
        {contacts.map((contact) => {
          return (
            <div className="flex items-center gap-[10px]">
              <img
                src={contact.img}
                className="sm:h-[4rem] sm:w-[4rem] h-[2.5rem] w-[2.5rem] rounded-md object-contain"
                alt="contact"
              />
              <a
                href={contact.url}
                target="_blank"
                rel="noreferrer"
                className={` text-lg font-outfit tracking-wide ${contact.textColor}`}
              >
                {' '}
                {contact.title}
              </a>
            </div>
          );
        })}
      </div>
      <div className="flex flex-col  items-center justify-center gap-5">
        <h1 className="text-center text-teal-100 brightness-105 tracking-wide text-lg ">
          You can contact me via any of the links above (preferably LinkedIn) ,
          or you can also use this contact form.
        </h1>
        {submitted && (
          <div className="transition-all duration-200 ease-in-out  flex flex-col items-center justify-center">
            <h1 className="text-teal-400 text-3xl font-semibold text-center ">
              Thanks For Contacting. Your Email Has been received
            </h1>
            <MdMarkEmailRead className="text-green-400 text-[5rem]" />
          </div>
        )}
        <form
          ref={form}
          onSubmit={sendEmail}
          className=" w-full flex flex-col items-center justify-center gap-4 bg-transparent"
        >
          <input
            className="text-teal-200 tracking-wide font-semibold  p-[10px] sm:w-[400px] w-[70%] bg-transparent border-4 border-double border-teal-300 outline-none  border-opacity-75 rounded-md caret-teal-500 placeholder:text-center placeholder:text-slate-400 shadow-sm shadow-teal-500"
            required
            type="text"
            name="user_name"
            placeholder="Your Name"
          />
          <input
            className="text-teal-200 tracking-wide font-semibold p-[10px] sm:w-[400px] w-[70%] bg-transparent border-4 border-double border-teal-300 outline-none  border-opacity-75 rounded-md caret-teal-500 placeholder:text-center placeholder:text-slate-400 shadow-sm shadow-teal-500"
            required
            type="email"
            name="user_email"
            placeholder="Your Email Adress"
          />{' '}
          <textarea
            className="text-teal-200 tracking-wide font-semibold p-[10px] sm:w-[400px] w-[70%] h-52 bg-transparent border-4 border-double border-teal-300 outline-none  border-opacity-75 rounded-md caret-teal-500 placeholder:text-center placeholder:text-slate-400 shadow-sm shadow-teal-500"
            required
            type="text"
            name="message"
            placeholder="Your Message"
          />
          {button ? (
            <button
              type="submit"
              className={`button hover:ring-4 hover:ring-slate-800 w-36 h-14 before:content-['Send_Message'] hover:before:content-[''] group p-[10px] relative cursor-pointer  after:content-[''] 
            after:absolute after:bg-gradient-to-tr after:from-teal-300 
            after:to-teal-400 after:w-0 after:h-full
        after:hover:w-full   after:right-0 after:bottom-0
        z-50 after:-z-50 hover:text-slate-900 after:transition-[width,0.4s,ease-in-out]
           border-4 border-double border-opacity-80 border-teal-400 rounded-md text-teal-400
           font-semibold `}
            >
              <p>
                {' '}
                <BiMailSend className="group-hover:w-full fill-slate-900  w-0 absolute group-hover:text-4xl group-active:w-0" />
                <MdMarkEmailRead className=" fill-slate-900  w-0 absolute group-active:text-4xl group-active:w-full" />
              </p>
            </button>
          ) : (
            <button
              type="submit"
              disabled
              className={`bg-green-400 w-36 h-14 rounded-md`}
            >
              <p>
                {' '}
                <MdMarkEmailRead className=" text-slate-900  text-4xl w-full" />
              </p>
            </button>
          )}
        </form>
      </div>
    </div>
  );
};

export default Contact;
